import { MailDetailsCustomNatureDataDto } from './mail-details-dto.';

export class MailMeSearchKanban {
  // implements MailMeSearchDto but with all datas not mandatory
  id?: number;
  serviceProprietaireId?: number;
  refExpediteur?: null | string;
  dateEncodage?: Date;
  dateEntree?: Date;
  dateDocument?: Date | null;
  dateEcheance?: Date;
  natureId?: number | null;
  supprime?: boolean;
  version?: number;
  centreNumerisationId?: null;
  datePostale?: Date | null;
  expediteurId?: number | null;
  expediteurIdiAdmin?: number | null;
  expediteurLibre?: string | null;
  sourceId?: number | null;
  confidentiel?: boolean;
  objet?: string;
  typeEntrantSortant?: InAndOutType;
  statutId?: number | null;
  avalider?: boolean;
  classementId?: number | null;
  classementCode?: string;
  classeurId?: number | null;
  classeurDescription?: null | string;
  chemiseId?: number | null;
  chemiseDescription?: null | string;
  remarques?: null | string;
  referenceRecommande?: null | string;
  nature?: MailNature | null;
  boiteArchive?: null | string;
  countLinks?: number;
  natureCustomDatas?: MailDetailsCustomNatureDataDto[];

  danger?: boolean;
  warning?: boolean;
  normal?: boolean;
  status?: number;
}

export enum InAndOutType {
  E = 'E',
  I = 'I',
  S = 'S',
}

export interface MailNature {
  id: number;
  description: string;
}
